export enum AppEnvironment {
    LOCAL = 'local',
    STAGING = 'staging',
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
}
